import Rive from '@rive-app/react-canvas';
import React from 'react';

import { Images } from '@/components';
import { TokenId, useTokenPrices } from '@/hooks/useTokenPrices';
import { useRouter } from '@/provider/RouterProvider';
import { getUsdWithToken, isRivFile } from '@/utils';
import { currencyFormatter } from '@/utils/currency';

const CardCollection: React.FC<{
  image: string;
  name: string;
  totalItem: number;
  tradingVolume: number;
  collectionId: number;
  className?: string;
}> = ({ image, tradingVolume, name, totalItem, collectionId, className = '' }) => {
  const router = useRouter();
  const { data: prices } = useTokenPrices();

  const airiToUsd = getUsdWithToken({
    amount: tradingVolume,
    tokenId: TokenId.AIRI,
    prices: prices || {},
  });

  return (
    <div
      onClick={() => router.push(`/collection/${collectionId}`)}
      className={`group relative mb-[20px] h-[370px] w-full cursor-pointer overflow-hidden rounded-[32px] p-[28px] ${className}`}
    >
      <div className="absolute left-0 top-0 z-[1] h-full w-full">
        {isRivFile(image ?? '') ? (
          <Rive src={image} stateMachines="state-machine" />
        ) : (
          <Images
            src={image}
            className="h-full w-full object-cover duration-1000 group-hover:scale-[1.15]"
            alt="collection"
          />
        )}
      </div>
      <div className="absolute left-0 top-0 z-[2] h-full w-full bg-[rgba(0,0,0,0.3)]" />
      <div className="relative z-[2] flex h-full flex-col justify-between">
        <div>
          <h4 className="line-clamp-1 text-[24px] font-[700] text-white lg:text-[20px]">{name}</h4>
        </div>
        <div className="flex items-end justify-between">
          <div>
            <p className="text-[16px] leading-[2] text-white lg:text-[14px]">Volume</p>
            <span className="lg-:text-[20px] text-[22px] font-bold leading-none text-white">
              {currencyFormatter(tradingVolume, { significantDigits: 3 })} AIRI
            </span>
            <p className="text-[14px] text-white">
              ≈ ${currencyFormatter(airiToUsd, { significantDigits: 3 })}
            </p>
          </div>
          <p className="rounded-[32px] bg-[rgba(255,255,255,0.3)] px-[14px] py-[10px] text-[14px] font-semibold text-white backdrop-blur-[2px]">
            {totalItem} items
          </p>
        </div>
      </div>
    </div>
  );
};

export default CardCollection;
